import moment from 'moment';
import React from 'react';

import {
  EAllowStatus,
  ExtendedIDSettingInherit,
  HeaderBidderActiveActive,
  MatchDealIDTypeDisabled,
  PrivateAuctionTypeDisabled,
  ResourceActiveDisabled,
  TargetBoolTypeAll,
  TargetingCCPAAll,
  TargetingCoppaAll,
  ETargetingDeviceIDTypes,
  TargetingGDPRAll,
  TargetingLogicOR,
  TargetingRequestedPodDurationNoMax,
  TargetingRequestedPodDurationNoMin,
} from '~/src/dash/api/console-api';
import { getMagniteCTVTiersEnabledForPublisher } from '~/src/dash/api/demand-settings/magnitectv/magnitectv-tiers_methods';
import { getSamsungSSPTiersEnabledForPublisher } from '~/src/dash/api/demand-settings/samsungssp/samsungssp-tiers_methods';
import { getSpotxTiersEnabledForPublisher } from '~/src/dash/api/demand-settings/spotx/spotx-tiers_methods';
import {
  EHeaderBidder_DealAtTargeting,
  EHeaderBidder_PositionTargeting,
  EHeaderBidder_ShareOfVoiceType,
  EStartDelay,
} from '~/src/dash/api/headerbidders/headerbidders_models';
import { EBool } from '~/src/dash/api/types/bool';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { ELogicalOperator } from '~/src/dash/utils/options';
import { IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { BidderSettingsFormView } from '~/src/dash/views/bidder-settings-form-view';
import { LoadingView } from '~/src/dash/views/loading-view';
import { ct } from '~/src/dash/publicaUI';

interface IProps extends IWithStylesProps, ISessionStateProps, IUserStateProps, IHistoryProps {}

export const BidderSettingsNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, any> {
    state = {
      spotxTierLoaded: false,
      spotxTierEnabled: EBool.EBool_FALSE,
      magniteCTVTierLoaded: false,
      magniteCTVTierEnabled: EBool.EBool_FALSE,
      err: undefined,
    };

    componentDidMount() {
      this.getIsMagniteCTVTiersEnabled();
      this.getIsSamsungSSPTiersEnabled();
      this.getIsSpotxTiersEnabled();
    }

    getIsSpotxTiersEnabled() {
      getSpotxTiersEnabledForPublisher(this.props.session.publisher.ID).then(
        ([_isEnabled, err]) => {
          if (err) {
            console.error(err);
            this.setState({
              err: err.message,
            });
          } else if (_isEnabled !== undefined) {
            this.setState({
              spotxTierLoaded: true,
              spotxTierEnabled: _isEnabled,
            });
          }
        },
      );
    }

    getIsMagniteCTVTiersEnabled() {
      getMagniteCTVTiersEnabledForPublisher(this.props.session.publisher.ID).then(
        ([_isEnabled, err]) => {
          if (err) {
            console.error(err);
            this.setState({
              err: err.message,
            });
          } else if (_isEnabled !== undefined) {
            this.setState({
              magniteCTVTierLoaded: true,
              magniteCTVTierEnabled: _isEnabled,
            });
          }
        },
      );
    }

    getIsSamsungSSPTiersEnabled() {
      getSamsungSSPTiersEnabledForPublisher(this.props.session.publisher.ID)
        .then((_isEnabled) => {
          if (_isEnabled !== undefined) {
            this.setState({
              magniteCTVTierLoaded: true,
              magniteCTVTierEnabled: _isEnabled,
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            err: 'Unable to load tiers enable status',
          });
        });
    }

    render() {
      const bulkUpdateString = 'bulk_edit_ids';
      const bulkUpdateEnabled = this.props.location.search.indexOf(bulkUpdateString);
      let bulkUpdateIDs = [] as string[];
      if (bulkUpdateEnabled > -1) {
        bulkUpdateIDs = this.props.location.search
          .slice(bulkUpdateEnabled + bulkUpdateString.length + 1)
          .split(',');
      }

      const cloneBidderString = 'clone-bidder';
      const cloneBidderEnabled = this.props.location.pathname.indexOf(cloneBidderString) > -1;

      const readAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);
      if (!readAuthorization.isAuthorized) {
        return (
          <div>
            <ModelMissingPermission missingPermissions={readAuthorization.missingPermissions} />
          </div>
        );
      }

      return (
        <div>
          {this.props.user.bidderParameters &&
          (!this.props.session.cloneBidderID ||
            (this.state.spotxTierLoaded && this.state.magniteCTVTierLoaded)) ? (
            <BidderSettingsFormView
              headerbidder={{
                ID: '',
                CreatedAt: '',
                UpdatedAt: '',
                DeletedAt: '',

                SiteID: '',
                Name: ct('NewItemName', { item: ct('Bidder') }),
                Bidder: '',
                Params: '',
                QPS: 0,
                Settings: '',
                Slots: [],
                TargetingDeviceMake: '',
                TargetingDeviceModel: '',
                TargetingDeviceOs: '',
                TargetingDeviceType: '',
                LivestreamTargeting: '',
                TargetingDevices: '0',
                TargetingDevicesIsAllowed: EAllowStatus.ALLOW,
                TargetingAudienceSegmentID: '',
                Priority: 10,
                HeaderBidders: [],
                Active: HeaderBidderActiveActive,
                TargetingDeviceCountry: '',
                LocalTargeting: '',
                IPFilter: '',
                LocalTargetingIsAllowed: true,
                TargetingAppBundleID: '',
                TargetingAppBundleIDIsAllowed: true,
                TargetingAudienceSegmentIDIsAllowed: EAllowStatus.ALLOW,
                TargetingAppBundleSitePagesLogic: ELogicalOperator.AND,
                TargetingCountryGroupIDs: '',
                TargetingCountryGroupIDsIsAllowed: EAllowStatus.ALLOW,
                HonorChannelFloor: EBool.EBool_TRUE,
                AnonymizeDeviceID: EBool.EBool_FALSE,
                AnonymizeIP: EBool.EBool_FALSE,
                TargetingDealID: '',
                TargetingDealIDIsAllowed: EBool.EBool_TRUE,
                AppBundleOverrideIfEmpty: EBool.EBool_FALSE,
                AppBundleOverride: '',
                AppIDOverride: '',
                AppIDOverrideIfEmpty: EBool.EBool_FALSE,
                AppNameOverrideIfEmpty: EBool.EBool_FALSE,
                AppNameOverride: '',
                AppDomainOverrideIfEmpty: EBool.EBool_FALSE,
                AppDomainOverride: '',
                ContentChannelOverride: '',
                ContentChannelOverrideIfEmpty: EBool.EBool_FALSE,
                ContentNetworkOverride: '',
                ContentNetworkOverrideIfEmpty: EBool.EBool_FALSE,
                ContentSeriesOverride: '',
                ContentSeriesOverrideIfEmpty: EBool.EBool_FALSE,
                ContentGenreOverride: '',
                ContentGenreOverrideIfEmpty: EBool.EBool_FALSE,
                ContentTitleOverride: '',
                ContentTitleOverrideIfEmpty: EBool.EBool_FALSE,
                ContentDistribNameOverride: '',
                ContentDistribNameOverrideIfEmpty: EBool.EBool_FALSE,
                ContentRatingOverride: '',
                ContentRatingOverrideIfEmpty: EBool.EBool_FALSE,
                ContentCategoryOverride: '',
                ContentCategoryOverrideIfEmpty: EBool.EBool_FALSE,
                ContentProdqualOverride: '',
                ContentProdqualOverrideIfEmpty: EBool.EBool_FALSE,
                ContentProducerNameOverride: '',
                ContentProducerNameOverrideIfEmpty: EBool.EBool_FALSE,
                ContentProducerIDOverride: '',
                ContentProducerIDOverrideIfEmpty: EBool.EBool_FALSE,
                ContentKeywordsOverride: '',
                ContentKeywordsOverrideIfEmpty: EBool.EBool_FALSE,
                ContentLanguageOverride: '',
                ContentLanguageOverrideIfEmpty: EBool.EBool_FALSE,
                ContentIDOverride: '',
                ContentIDOverrideIfEmpty: EBool.EBool_FALSE,
                ContentSeasonOverride: '',
                ContentSeasonOverrideIfEmpty: EBool.EBool_FALSE,
                EndpointDealIDPassthroughActive: EBool.EBool_FALSE,
                InventoryPartnerDomainOverride: '',
                InventoryPartnerDomainOverrideIfEmpty: EBool.EBool_FALSE,
                RemoveContentFromBidRequest: EBool.EBool_FALSE,
                RemoveContentChannelFromBidRequest: EBool.EBool_FALSE,
                RemoveContentNetworkFromBidRequest: EBool.EBool_FALSE,
                RemoveContentSeriesFromBidRequest: EBool.EBool_FALSE,
                RemoveContentTitleFromBidRequest: EBool.EBool_FALSE,
                RemoveContentGenreFromBidRequest: EBool.EBool_FALSE,
                RemoveContentDistribNameFromBidRequest: EBool.EBool_FALSE,
                RemoveContentCategoryFromBidRequest: EBool.EBool_FALSE,
                RemoveContentRatingFromBidRequest: EBool.EBool_FALSE,
                RemoveContentProdqualFromBidRequest: EBool.EBool_FALSE,
                RemoveContentProducerNameFromBidRequest: EBool.EBool_FALSE,
                RemoveContentProducerIDFromBidRequest: EBool.EBool_FALSE,
                RemoveContentKeywordsFromBidRequest: EBool.EBool_FALSE,
                RemoveContentLanguageFromBidRequest: EBool.EBool_FALSE,
                RemoveContentIDFromBidRequest: EBool.EBool_FALSE,
                RemoveContentSeasonFromBidRequest: EBool.EBool_FALSE,
                CustomTargeting: '',
                CustomTargetingInclusion: EAllowStatus.ALLOW,
                Custom4: '',
                Custom4Inclusion: EAllowStatus.ALLOW,
                Custom5: '',
                Custom5Inclusion: EAllowStatus.ALLOW,
                Custom6: '',
                Custom6Inclusion: EAllowStatus.ALLOW,
                Custom7: '',
                Custom7Inclusion: EAllowStatus.ALLOW,
                Custom8: '',
                Custom8Inclusion: EAllowStatus.ALLOW,
                Custom9: '',
                Custom9Inclusion: EAllowStatus.ALLOW,
                Custom10: '',
                Custom10Inclusion: EAllowStatus.ALLOW,
                Custom11: '',
                Custom11Inclusion: EAllowStatus.ALLOW,
                Custom12: '',
                Custom12Inclusion: EAllowStatus.ALLOW,
                Custom13: '',
                Custom13Inclusion: EAllowStatus.ALLOW,
                Custom14: '',
                Custom14Inclusion: EAllowStatus.ALLOW,
                Custom15: '',
                Custom15Inclusion: EAllowStatus.ALLOW,
                Custom16: '',
                Custom16Inclusion: EAllowStatus.ALLOW,
                Custom17: '',
                Custom17Inclusion: EAllowStatus.ALLOW,
                Custom18: '',
                Custom18Inclusion: EAllowStatus.ALLOW,
                TargetingContentChannel: '',
                TargetingContentChannelIsAllowed: EAllowStatus.ALLOW,
                TargetingContentDistributor: '',
                TargetingContentDistributorIsAllowed: EAllowStatus.ALLOW,
                TargetingContentGenre: '',
                TargetingContentGenreIsAllowed: EAllowStatus.ALLOW,
                TargetingContentID: '',
                TargetingContentIDIsAllowed: EAllowStatus.ALLOW,
                TargetingContentNetwork: '',
                TargetingContentNetworkIsAllowed: EAllowStatus.ALLOW,
                TargetingContentProducer: '',
                TargetingContentProducerIsAllowed: EAllowStatus.ALLOW,
                TargetingContentRating: '',
                TargetingContentRatingIsAllowed: EAllowStatus.ALLOW,
                TargetingContentSeries: '',
                TargetingContentSeriesIsAllowed: EAllowStatus.ALLOW,
                TargetingContentTitle: '',
                TargetingContentTitleIsAllowed: EAllowStatus.ALLOW,
                TargetingContentCategory: '',
                TargetingContentCategoryIsAllowed: EAllowStatus.ALLOW,
                TargetingContentLanguage: '',
                TargetingContentLanguageIsAllowed: EAllowStatus.ALLOW,
                ChannelGroupIDS: [],
                SiteIDS: [],
                CampaignIDS: [],
                OrderIDS: [],
                MinAdDurationOverride: 0,
                MaxAdDurationOverride: 0,
                Skip: EBool.EBool_FALSE,
                SkipMin: 0,
                SkipAfter: 0,
                TargetingDeviceTypes: '',
                TargetingDeviceTypesIsAllowed: EAllowStatus.ALLOW,
                TargetingDeviceSubTypes: '',
                TargetingDeviceSubTypesIsAllowed: EAllowStatus.ALLOW,
                TargetingCoppa: TargetingCoppaAll,
                TargetingLimitedAdTracking: TargetBoolTypeAll,
                SiteDomainOverride: '',
                SiteNameOverride: '',
                FrequencyActive: ResourceActiveDisabled,
                FrequencyTTL: 0,
                FrequencyLimit: 1,
                PrivateAuction: PrivateAuctionTypeDisabled,
                MatchDealID: MatchDealIDTypeDisabled,
                StartDate: undefined,
                EndDate: undefined,
                Quantity: 0,
                CRONQuantityCount: 0,
                MultiBidActive: EBool.EBool_FALSE,
                UnpaidBidderEnabled: EBool.EBool_FALSE,
                FallbackAuctionParticipationEnabled: EBool.EBool_TRUE,
                ShareOfVoiceType: EHeaderBidder_ShareOfVoiceType.HeaderBidder_ShareOfVoiceType_POD,
                AuctionParticipationPercentage: 100,
                DOOHEnabled: EBool.EBool_FALSE,
                RemoveFmtJSON: EBool.EBool_FALSE,
                FlexibleBiddingThresholds: [],
                FlexibleBiddingEnabled: EBool.EBool_FALSE,
                PacingType: 1,
                PlaybackMethod: '1',
                ShareOfVoice: 100,
                BidAdjustmentFactor: 100,
                BidAdjustmentValue: 0,
                FrequencyCap: 0,
                BidFloor: '0',
                Timeout: 0,
                TmaxOffset: 0,
                StartDelayOverride: EStartDelay.StartDelay_UnknownNotSet,
                ClearDefaultBitrateLimits: EBool.EBool_FALSE,
                PositionTargeting:
                  EHeaderBidder_PositionTargeting.HeaderBidder_PositionTargeting_ALL,
                TargetingSitePages: '',
                TargetingSitePagesIsAllowed: EAllowStatus.ALLOW,
                TargetingSiteDomain: '',
                TargetingSiteDomainIsAllowed: EAllowStatus.ALLOW,
                EnableIrisSignal: EBool.EBool_FALSE,
                EnforceSlotTargeting: EBool.EBool_FALSE,
                LocalTargetingLogic: TargetingLogicOR,
                TargetingFWSectionIDs: '',
                TargetingFWSectionIDsIsAllowed: EAllowStatus.ALLOW,
                VastExtensionPriceEnabled: EBool.EBool_FALSE,
                TargetingPrice: '',
                TargetingPriceIsAllowed: EAllowStatus.ALLOW,
                SubPriority: 1, // default subtier priority is 1 = subtier 10 displayed on UI
                Timezone: this.props.session.publisher.Timezone,
                DealAtTargeting: EHeaderBidder_DealAtTargeting.HeaderBidder_DealAtTargeting_None,
                TargetingCCPA: TargetingCCPAAll,
                TargetingGDPR: TargetingGDPRAll,
                TargetingGDPRConsent: TargetBoolTypeAll,
                TargetingDeviceIDType: ETargetingDeviceIDTypes.ALL,
                EnableRemoveGPPFromBidRequest: EBool.EBool_FALSE,
                EnableSecondaryRequests: EBool.EBool_FALSE,
                EnableSponsorshipMode: EBool.EBool_FALSE,
                SamplingPercentageDisabledUntil: moment
                  .utc(new Date())
                  .format('YYYY-MM-DDTHH:mm:ssZ'),
                SamplingPercentage: 1,
                DOOHDeviceTypeRewriteEnabled: EBool.EBool_FALSE,
                BidderLabels: [],
                YahooConnectIDEnabled: EBool.EBool_FALSE,
                TargetingRequestedPodDurationMin: TargetingRequestedPodDurationNoMin,
                TargetingRequestedPodDurationMax: TargetingRequestedPodDurationNoMax,
                Dayparting: [],
                TargetingGvinParamExists: EBool.EBool_FALSE,
                EnableTargetingFirstAdbreakInUserSession: EBool.EBool_FALSE,
                LiverampExtendedIDSetting: ExtendedIDSettingInherit,
                GooglePairExtendedIDSetting: ExtendedIDSettingInherit,
                UID2ExtendedIDSetting: ExtendedIDSettingInherit,
              }}
              bulkUpdateIDs={bulkUpdateIDs}
              headerbidderParamOptions={this.props.user.bidderParameters}
              existing={false}
              expandedTargetingPanels={[
                'Inventory',
                'Content',
                'Geo',
                'User',
                'Custom',
                'Device',
                'App',
                'Deals',
                'Stream',
              ]}
              expandedOverridePanels={[]}
              isSpotxTierEnabled={this.state.spotxTierEnabled}
              isMagniteCTVTierEnabled={this.state.magniteCTVTierEnabled}
              isSamsungSSPTierEnabled={this.state.magniteCTVTierEnabled}
              cloneBidderEnabled={cloneBidderEnabled}
              cloneBidderID={parseLocation(this.props.location.pathname).bidder || ''}
            />
          ) : (
            <LoadingView active={true} text={ct('LoadingEllipsis')} />
          )}
        </div>
      );
    }
  },
);
